// Auth
export const LOGGED_IN_SUCCES = 'LOGGED_IN_SUCCESS'
export const SIGN_OUT = 'SIGN_OUT'

// Profile
export const GET_USER_PROFILE_DATA = 'GET_USER_PROFILE_DATA'

// Repos - Orgs
export const GET_REPOS_DATA = 'GET_REPOS_DATA'
export const GET_ORGS_DATA = 'GET_ORGS_DATA'
export const GET_REPOS_IN_ORGS = 'GET_REPOS_IN_ORGS'
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS'

// Webhook
export const ADD_WEBHOOK = 'ADD_WEBHOOK'
export const DELETE_WEBHOOK = 'DELETE_WEBHOOK'

// Notifications
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'
export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS'
export const FETCH_NOTIFICATIONS_LENGTH = 'FETCH_NOTIFICATIONS_LENGTH'

// Toggel
export const SHOW_NOTIFICATIONS = 'SHOW_NOTIFICATIONS'
export const SHOW_REPOSITORIES = 'SHOW_REPOSITORIES'
export const SHOW_ORGANIZATION = 'SHOW_ORGANIZATION'
export const SHOW_PROFILE = 'SHOW_PROFILE'
export const SHOW_SUBSCRIPTIONS = 'SHOW_SUBSCRIPTIONS'
